<h2 mat-dialog-title>
  {{ 'REQUEST_SPEND_CHANGE_DIALOG.REQUEST_SPEND_CHANGE' | translate }}
</h2>
<mat-dialog-content>
  <div class="request-spend-change-text">
    {{ 'REQUEST_SPEND_CHANGE_DIALOG.REQUEST_CHANGE_IN_SPEND' | translate }}
  </div>
  @if (!isLoading) {
    <billing-ui-variable-price-input
      [appPrice]="appPricing"
      [currencyCode]="currency"
      [displayAddNote]="true"
      [currentSpendAmount]="this.currentSpendAmount"
      [displaySetupFee]="false"
      (spendAmountChanged)="changeSpendAmount($event)"
      (requesterNoteChanged)="changeRequesterNote($event)"
    ></billing-ui-variable-price-input>
  } @else {
    <div class="loading-spinner">
      <mat-spinner diameter="36"></mat-spinner>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose color="primary">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="requestSpendChange()" [disabled]="spendChangeSent || isLoading">
    {{ 'REQUEST_SPEND_CHANGE_DIALOG.REQUEST_CHANGE' | translate }}
  </button>
</mat-dialog-actions>

